import axios from 'axios';

function useDiscord() {
  const urlEndpoint = process.env.REACT_APP_FISH_BE_ENDPOINT;

  const updateDiscordInfo = async (discordData) => {
    let url_updateDiscord = urlEndpoint + '/discord/update-discord-info';
    try {
      const response = await axios.post(
        url_updateDiscord,
        {
          subject: discordData ? discordData.subject : null,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('fishAuth')}`,
          },
        }
      );
      console.log('Update discord info successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error update discord:', error);
      throw error;
    }
  };

  return {
    updateDiscordInfo,
  };
}

export default useDiscord;
